<template>
    <div style="background: #FAFAFA;">
        <SuperKidPublicHeader></SuperKidPublicHeader>
        <div class="container" style="padding-bottom: 40px; padding-top: 0.5rem">

            <div class="top-spot mt-5">
                <h5 @click="goToHome()"><span><i class="fa fa-chevron-left"></i></span>Kid Submission</h5>
            </div>
            <div v-if="loading">
                <PageLoader></PageLoader>
            </div>
            <div v-else class="display-body">
                <div class="row justify-content-center">
                    <div class="col-md-4">
                       <div class="chalenge-item">
                            <div class="kid-name-profile">
                                <img v-if="kidData.avatar_url != null" :src="kidData.avatar_url" alt="pix" style="width: 38px; height: 38px; border: 1px solid #e2e3e3">
                                <img v-else src="../../assets/icons/profile-icon.svg" alt="pix">
                                <div>
                                    <h5>{{kidData.firstname}} {{ kidData.lastname }}</h5>
                                    <!-- <p>#{{postings.data.challenge_category.name.replace(/\s+/g, '')}}</p> -->
                                </div>
                            </div>

                            <div class="challenge-body">
                                <!-- <h3>Wole Soyinka</h3> -->
                                <h4>{{ postings.title }}</h4>
                                <h6 v-if="postings">#{{postings.challenge_category.name.replace(/\s+/g, '')}}</h6>

                                <div v-if="submissionData && submissionData.submission.media">
                                    <img v-if="getPriorityMedia(submissionData.submission.media).url && getPriorityMedia(submissionData.submission.media).media_type === 'image'"  class="w-100" :src="getPriorityMedia(submissionData.submission.media).url" alt="media">
                                    <!-- Display Image if type is image -->
                                    <!-- <img v-if="item.media.media_type === 'image'" :src="item.media.url" alt="Gallery Image" class="w-100" /> -->

                                    <!-- Display Video if type is video -->
                                    
                                    <video v-else-if="getPriorityMedia(submissionData.submission.media).media_type === 'video'" 
                                        :src="getPriorityMedia(submissionData.submission.media).url" controls>
                                    Your browser does not support the video tag.
                                    </video>
                                    
                                </div>
                                <p v-if="submissionData && (mediaObject).length > 1 " class="view-more" data-toggle="modal" data-target="#mediaView" @click="modalMedia = submissionData.submission.media;">view more...</p>

                                <!-- <div>
                                    <img class="w-100" src="https://res.cloudinary.com/dr2wljdlc/image/upload/v1772108831/artwork_pdu1q6.svg" alt="media">
                                    
                                </div> -->

                                <h5 class="vote-ends">Voting ends: {{ postings.voting_end_date_and_time | moment }}</h5>

                                <div class="form-group vote-btn">
                                    <button @click="voteNow(posting)" class="btn vote-now mb-2">
                                        {{ loader ? 'Voting...': 'Vote now'}}
                                            <i
                                            class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                            v-if="loader"
                                            ></i>
                                    </button>
                                    <!-- <button class="btn vote-now" disabled v-if="item.voted == 'YES'">Voted</button> -->
                                    
                                </div>
                            </div>

                            <div class="modal fade" id="mediaView" tabindex="-1" aria-labelledby="mediaView" aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title title-modal" id="media-view">More Media</h5>
                                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                            </button>
                                        </div>
                                        <div class="modal-body more-media">
                                            <div v-for="(more, index) in modalMedia" :key="index" class="">
                                                
                                                <img v-if="more.url && more.media_type === 'image'"  class="w-100 mb-3" :src="more.url" alt="media">
                                                
                                                <!-- Display Image if type is image -->
                                                <!-- <img v-if="item.media.media_type === 'image'" :src="item.media.url" alt="Gallery Image" class="w-100" /> -->

                                                <!-- Display Video if type is video -->
                                                
                                                
                                                <video class="mb-3" v-if="more.media_type === 'video'" 
                                                    :src="more.url" controls style="width: 100%;">
                                                    Your browser does not support the video tag.
                                                </video>
                                                
                                                
                                            </div>
                                        </div>
                                
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                            <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                       </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>



<script>
import { Service } from "../../store/service";
const Api = new Service();
import PageLoader from "../../components/PageLoader.vue";
import SuperKidPublicHeader from "../../views/SuperKidPublicHeader.vue"
import moment from "moment";
import $ from "jquery";
export default {
    name: "SubmissionShared",
    components: {
        PageLoader,
        SuperKidPublicHeader
    },

    data() {
        return {
            loading: false,
            loader: false,
            submissionData: {
                submission: {
                    // media: [
                    // ]
                },
               
            },
            kidDetails: null,
            modalMedia: '',
            postings: "",
            mediaObject: '',
            posting_id: "",
            kidData: "",
            // baseUrl: '',
        };
    },
   
    created() {
      
    },
    // beforeDestroy() {
    //     // Destroy the data when you leave this component
    //     localStorage.removeItem('kidSubmission');
    //     console.log("Data cleared from storage");
    // },
    // beforeRouteLeave(to, from, next) {
    //     localStorage.removeItem('kidSubmission');
    //     next(); // Always call next() to allow the navigation to proceed
    // },
    mounted() {
        this.fetchSharedSubmition()
    },
    methods: {
        routeTo(route) {
            this.$router
            .push({
            path: `${route}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        goBack() {
            this.$router.go(-1);
        },
        goToHome() {
            this.$router
            .push({
            path: `${'superkids'}`
            })
            .catch(() => {
            // console.log("none")
            });
        },
        // This function is also in HomeSuperkid file take note
        getPriorityMedia(files) {
            // console.log("Files img", files)
            if (!files || !Array.isArray(files)) return null;
            // return files.find(file => file.media_type === 'image'); //uncomment later and comment out the next lines

            // const lastImage = [...files].reverse().find(file => file.media_type === 'image');
            // return lastImage ? lastImage.url : null;

            // const firstImage = files.find(f => f.media_type === 'image');
            // if (firstImage) return firstImage;  

            const lastImage = [...files].reverse().find(f => f.media_type === 'image');
            if (lastImage) return lastImage;

            // 2. If no image, find the first video
            const firstVideo = files.find(f => f.media_type === 'video');
            if (firstVideo) return firstVideo;

            return null;
            
        },
        fetchSharedSubmition() {
            this.loading = true;
            // fetch-postings-randomly
            const challengeid = this.$route.params.cid;
            const kidId = this.$route.params.kidid
            Api.getRequest(`fetch-super-kids-challenge-by-id-and-kid-id/${challengeid}/${kidId}`).then(res => {
                // console.log("Posting list Shared", res);
                this.loading = false;
                if(res.data.success) {
                    this.postings = res.data.data;
                    this.submissionData = res.data;
                    this.kidData = res.data.kid_data;
                    this.mediaObject = res.data.submission.media;
                    this.search = '';
                    const testing = {
                        created_at: "2026-03-24T02:43:13.000000Z",
                        url: "https://res.cloudinary.com/dr2wljdlc/image/upload/v1772108831/artwork_pdu1q6.svg",
                        id: 4,
                        media_type: "image",
                        super_kid_challenge_postings_id: "1",
                        updated_at: "2026-03-24T02:43:13.000000Z"
                    }
                    // this.postings.map(media => [...media, testing]);
                    // used when testing files
                    // this.postings = this.postings.map(user => ({
                    //     ...user,
                    //     media: [...(user.media || []), testing]
                    // }));
                   
                }
                if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                }
            }).catch(err => {
                console.log("err:", err);
                this.loading = false;
            })
        },
        voteNow(data) {
            this.loader = true;
            try {
                Api.postRequest(`vote`, {
                    platform: 'web',
                    posting_id: data.id,
                }).then (res => {
                    // console.log("Voted response", res);
                    this.loader = false;
                    if (res.data.success) {
                        this.fetchSharedSubmition();
                        return this.$store.commit("setApiSuccess", "Voted successfull");
                    }
                    if (res.data.error) {
                        return this.$store.commit("setApiFailed", res.data.error);
                    }
                }).catch(err => {
                    console.log("err:", err);
                    this.loader = false;
                })
            } finally {
                // console.log("closed")
            }
        },
    },
    filters: {
        moment: function(date) {
            return moment(date).format("MMMM Do YYYY, h:mm:ss a");
        }
    }
};

</script>



<style scoped lang="scss">

.top-spot {
    margin-top: 30rem;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    h5 {
        cursor: pointer;
        font-family: Lato;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #4B4B4F;
        span {
            margin-right: 20px;
        }
    }
    button {
        background: #2EBFCA;
        color: #F5F7FA;
        font-family: Lato;
        font-weight: 600;
        font-size: 16px;
        border-radius: 50px;
    }
}

.display-body {
    margin-top: 45px;
}

.chalenge-item {
    background: #ffffff;
    border-radius: 20px;
    border: 1px solid #F5F7FA;
    padding: 12px;
    margin-bottom: 15px;
}

.kid-name-profile {
    display: flex;
    gap: 10px;
    text-align: left;
    align-items: center;
    margin-bottom: 30px;
    img {
        border-radius: 50px;
    }
    h5 {
        font-family: Lato;
        font-weight: 700;
        font-size: 16px;
        line-height: 16px;
        color: #1C2B3A;
        margin-bottom: 0;
    }
    p {
        margin-bottom: 0;
        color: #5D6F7C;
        font-family: Lato;
        font-weight: 800;
        font-size: 11px;
        line-height: 20px;

    }
}

.challenge-body {
    img {
    border-radius: 8px;
    max-height: 339px;
    height: 100%;
    object-fit: contain;
   }
   video {
        border-radius: 8px;
        // width: 600px;
        // max-height: 499px;
        max-height: 329px;
        height: 100%;
        object-fit: contain;
        width: 100%;
    }
    h3 {
        text-align: left;
        font-family: Nunito Sans;
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        // color: #1C2B3A;
    }
    h4, h6 {
        font-family: Lato;
        font-weight: 400;
        font-size: 16px;
        line-height: 26px;
        text-align: left;
    }
    h4 {
        color:  #5D6F7C;
    }
    h3 {
        color: #1C2B3A;
    }
    h6 {
        margin-top: 20px;
        color: #2EBFCA
    }
    .view-more {
        color: #2AB3E6;
        font-family: Lato;
        font-size: 20px;
        cursor: pointer;
        text-align: right;
    }
}

.vote-ends {
    font-family: Lato;
    font-size: 14px;
    text-align: left;
    color: #1A1A1A;
    margin-top: 10px;
}

.vote-btn {
    margin-top: 40px;
    .vote-now {
        background: #2AB3E6;
        color: #ffffff;
        border-radius: 50px;
        min-height: 38px;
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        width: 100%;
        outline: 0;
        box-shadow: none;
    }
    .copy-now {
        background: #CAECF9;
        color: #ffffff;
        border-radius: 50px;
        min-height: 38px;
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        width: 100%;
        outline: 0;
        box-shadow: none;
    }
}

.more-media {
    img {
        max-height: 600px;
        height: 100%;
        object-fit: contain;
    }
    video {
        // max-height: 600px;
        height: 100%;
        object-fit: contain;
    }
}
</style>